<template>
  <modal-wrapper @close="close">
    <modal-container :title="title" :show-close="showClose" @close="close">
      <div class="common-modal">
        <img
          v-if="imgSrc"
          :src="imgSrc"
          alt="modal img"
          class="common-modal__img"
        />
        <div v-if="heading" class="common-modal__title">
          {{ heading }}
        </div>
        <div v-if="textArray" class="common-modal-text-box">
          <p
            v-for="(text, idx) in textArray"
            :key="idx"
            class="common-modal-text-box__text"
          >
            {{ text }}
          </p>
        </div>
        <div v-if="$slots.buttons" class="common-modal-buttons">
          <slot name="buttons"></slot>
        </div>
      </div>
    </modal-container>
  </modal-wrapper>
</template>

<script>
import ModalWrapper from '@/components/modals/ModalWrapper.vue'
import ModalContainer from '@/components/modals/ModalContainer.vue'
export default {
  name: 'CommonModal',
  components: { ModalContainer, ModalWrapper },
  props: {
    title: {
      type: String,
      default: null
    },
    heading: {
      type: String,
      default: null
    },
    imgSrc: {
      type: String,
      default: null
    },
    textArray: {
      type: Array,
      default: null
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/components/modals/CommonModal.scss";
</style>
